import { Report } from 'types/report';

export const calTotals = (report: Report) => {
  if (!report)
    return {
      beginning: 0,
      ending: 0,
      totalDelivered: 0,
      returnedDirty: 0,
      returnedUnused: 0,
      totalReturned: 0,
      totalAvailable: 0,
      totalAccountFor: 0,
    };
  return report?.details?.reduce(
    (acc, cur) => {
      acc.beginning = Number(cur.beg) + acc.beginning;
      acc.ending = Number(cur.end) + acc.ending;
      acc.totalDelivered = Number(cur.del) + acc.totalDelivered;
      acc.returnedDirty = Number(cur.ret) + acc.returnedDirty;
      acc.returnedUnused = Number(cur.unu) + acc.returnedUnused;

      acc.totalReturned = acc.returnedDirty + acc.returnedUnused;
      acc.totalAccountFor = acc.totalReturned + acc.ending;
      acc.totalAvailable = acc.beginning + acc.totalDelivered;

      return acc;
    },
    {
      beginning: 0,
      ending: 0,
      totalDelivered: 0,
      returnedDirty: 0,
      returnedUnused: 0,
      totalReturned: 0,
      totalAvailable: 0,
      totalAccountFor: 0,
    },
  );
};

export const calHarvestRate = (report: Report) => {
  if (!report) return;
  const _calTotals = calTotals(report);
  return _calTotals?.totalAvailable > 0
    ? ((_calTotals?.totalAccountFor / _calTotals.totalAvailable) * 100).toFixed(
        2,
      )
    : '0.00';
};
